import { IState } from '../store';

export function selectMortgageGallery(state: IState) {
  return state.mortgageGallery;
}
